'use strict'

import * as BasUtil from '@basalte/bas-util'

/**
 * Service for handling streaming service login via the LoginTopic.
 * Currently only used for B&O devices(Deezer, Tidal).
 * In the future, this service will be extended to handle login for all
 * devices.
 */

angular
  .module('basalteApp')
  .service('BoLogin', [
    '$rootScope',
    'BAS_API',
    'BAS_STREAMING',
    'BAS_CURRENT_CORE',
    'CurrentBasCore',
    BoLogin
  ])

/**
 *
 * @typedef {Object} TBoLoginState
 * @property {Object<string, TLoginTopicService>} services
 */

/**
 * @param $rootScope
 * @param BAS_API
 * @param BAS_STREAMING
 * @param {BAS_CURRENT_CORE} BAS_CURRENT_CORE
 * @param {CurrentBasCore} CurrentBasCore
 */
function BoLogin (
  $rootScope,
  BAS_API,
  BAS_STREAMING,
  BAS_CURRENT_CORE,
  CurrentBasCore
) {
  let _loginTopicListeners = []

  /**
   * @type {TCurrentBasCoreState}
   */
  const currentBasCoreState = CurrentBasCore.get()

  /**
   * @type {TBoLoginState}
   */
  const state = {
    services: {}
  }

  this.get = get
  this.hasBoLoginSupport = hasBoLoginSupport

  init()

  function init () {

    $rootScope.$on(
      BAS_CURRENT_CORE.EVT_CORE_CORE_V2_CONNECTED,
      function (_event, _core, isConnected) {

        BasUtil.executeArray(_loginTopicListeners)
        _loginTopicListeners = []
        state.services = {}
        $rootScope.$emit(BAS_STREAMING.EVT_STREAMING_SERVICES_UPDATED)
        $rootScope.$applyAsync()

        if (isConnected) {

          const loginTopic = _getLoginTopic()

          if (loginTopic) {

            loginTopic.subscribe().then(_onLoginTopicAvailable)
          }
        }
      }
    )
  }

  function _onLoginTopicAvailable () {

    const loginTopic = _getLoginTopic()

    if (!loginTopic) return

    _loginTopicListeners.push(BasUtil.setEventListener(
      loginTopic,
      BAS_API.LoginTopic.EVT_SERVICE_UPDATED,
      _getStreamingServices
    ))

    _getStreamingServices()
  }

  function _getStreamingServices () {

    const loginTopic = _getLoginTopic()

    if (!loginTopic) return

    loginTopic.listStreamingServices()
      .then(function (services) {
        state.services = services
        $rootScope.$emit(BAS_STREAMING.EVT_STREAMING_SERVICES_UPDATED)
        $rootScope.$applyAsync()
      })
  }

  /**
   * @returns {TBoLoginState}
   */
  function get () {

    return state
  }

  /**
   * @returns {boolean}
   */
  function hasBoLoginSupport () {

    return !!(
      state.services[BAS_STREAMING.K_ID_BO_DEEZER] ||
      state.services[BAS_STREAMING.K_ID_BO_TIDAL]
    )
  }

  /**
   * @private
   * @returns {?LoginTopic}
   */
  function _getLoginTopic () {

    return currentBasCoreState.core?.core?.loginTopic
  }
}
